import React, { Fragment, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Auth } from "aws-amplify";
import { toast } from "react-toastify";
import { Dialog, Transition } from '@headlessui/react';
import { Menu, MenuHandler, MenuItem, MenuList, Popover, PopoverContent, PopoverHandler, Spinner } from '@material-tailwind/react';
import { BellIcon, BusinessIcon, InfoIcon, InvoiceIcon, LinkIcon, PaymentIcon, ProfileIcon, SettingIcon, ShareIcon, SubscriptionIcon } from '../../Assets/AllSvg';
import { IoChevronDownSharp, IoClose } from "react-icons/io5";
import { FiSearch } from "react-icons/fi";
import { RiMenu2Line } from "react-icons/ri"
import AddAccountNameModal from '../AddAccountNameModal/AddAccountNameModal';
import KeyShortcutSidebar from '../KeyShortcutSidebar/KeyShortcutSidebar';


const DashboardHeader = () => {
    const [open, setOpen] = useState(false)
    const [active, setActive] = useState(false)
    const [enabledCheck, setEnabledCheck] = useState(false);
    const [modal, setModal] = useState(false)
    const [openPopover, setOpenPopover] = useState(false);
    const [openMenu, setOpenMenu] = useState(false)
    const location = useLocation();
    const navigate = useNavigate();

    const singOutUser = async () => {
        try {
            await Auth.signOut();
            setTimeout(() => {
                setModal(false)
                navigate("/signIn");
            }, 300);
            localStorage.setItem("user", '');
            localStorage.setItem("client_id", '');
            localStorage.setItem("email", '');
        } catch (error) {
            toast.error(error.message, { autoClose: 5000 });
        }
    };
    const triggers = {
        onMouseEnter: () => setOpenPopover(true),
        onMouseLeave: () => setOpenPopover(false),
    };
    const productTrue = location.pathname.includes('product')
    const customerTrue = location.pathname.includes('customers')

    const menu = [
        { name: "home", route: "/dashboard" },
        { name: "payments", route: "/payments" },
        { name: "balances", route: "/balances" },
        { name: "customers", route: "/customers", nav: customerTrue },
        { name: "products", route: "/product", nav: productTrue },
        { name: "billing", route: "/billing" },
        { name: "reports", route: "/reports" },
        { name: "connect", route: "/connect" },
    ]

    return (
        <>
            <div className='sticky top-0 z-10'>
                <div className="bg-[rgb(246,248,250)] border-b-[1px] border-[#ebeef1]">
                    <div className="max-w-[1690px] mx-auto sm:px-[40px] px-[20px] py-[8px] w-full text-[#414552]">
                        <div className="flex xs:flex-row flex-col gap-2 justify-between items-center">
                            <div>
                                <div className="flex items-center gap-2">
                                    <div className="h-[28px] w-[28px] flex justify-center items-center bg-white rounded-full shadow-[0_2px_5px_0_rgba(65,69,82,0.08),0_1px_1px_0_rgba(0,0,0,.12)]"><BusinessIcon /></div>
                                    <div className='group flex gap-2 transition-all items-center cursor-pointer' onClick={() => setOpen(true)}>
                                        <span className="text-xs font-semibold">New Business</span>
                                        <IoChevronDownSharp className='opacity-0 group-hover:opacity-100 transition-all' />
                                    </div>
                                </div>
                            </div>
                            <div className='md:block hidden'>
                                <div className='relative w-full group'>
                                    <FiSearch className='absolute top-[6px] text-[14px] left-[10px] text-[#414552]' />
                                    <input type="text" className='lg:w-[491px] w-[280px] focus:outline-none p-[4px_32px] text-[12px] h-[26px] text-[#6b7183] placeholder:text-[#6b7183] border-[1px] border-[#ebeef1] rounded-full bg-white placeholder:text-[12px] font-semibold' placeholder='Search...' />
                                    <div className='h-[18px] text-[12px] w-[18px] group-hover:opacity-100 opacity-0 right-3 bg-[#f5f6f8] absolute flex items-center justify-center top-[4px] rounded'>/</div>
                                </div>
                            </div>
                            <div className='xs:w-max w-full'>
                                <div className='flex sm:gap-4 gap-2 items-center xs:w-max w-full justify-between'>
                                    <Menu placement='bottom-end'>
                                        <MenuHandler>
                                            <button className='sm:p-[2px_12px] p-[2px_8px] flex gap-1 text-[12px] items-center font-semibold text-[#625afa] border-[1px] border-[#625afa] rounded-full hover:bg-[#625afa] hover:text-white'>Create <IoChevronDownSharp className='text-[16px] translate-y-[1px]' /></button>
                                        </MenuHandler>
                                        <MenuList className='py-[8px] px-0'>
                                            <span className='px-[12px] pb-2 text-[#687385] py-[4px] text-xs font-medium'>ONLINE PAYMENTS</span>
                                            <MenuItem className='mt-1 flex justify-between items-center rounded-none hover:text-[#625afa] text-[#625afa] hover:bg-[#f7f7f7] py-[5px]'>
                                                <div className='flex gap-2 items-center font-medium'>
                                                    <InvoiceIcon className="fill-[#625afa] h-[12px] w-[12px]" /> Invoice
                                                </div>
                                                <div className='flex gap-1 text-[12px] text-[#685387]'>
                                                    <div className='bg-[#f2f4f7] w-[16px] h-[16px] flex justify-center items-center rounded'>c</div>
                                                    <div className='bg-[#f2f4f7] w-[16px] h-[16px] flex justify-center items-center rounded'>i</div>
                                                </div>
                                            </MenuItem>
                                            <MenuItem className='flex justify-between items-center rounded-none hover:text-[#625afa] text-[#625afa] hover:bg-[#f7f7f7] py-[5px]'>
                                                <div className='flex gap-2 items-center font-medium'>
                                                    <SubscriptionIcon /> Subscription
                                                </div>
                                                <div className='flex gap-1 text-[12px] text-[#685387]'>
                                                    <div className='bg-[#f2f4f7] w-[16px] h-[16px] flex justify-center items-center rounded'>c</div>
                                                    <div className='bg-[#f2f4f7] w-[16px] h-[16px] flex justify-center items-center rounded'>s</div>
                                                </div>
                                            </MenuItem>
                                            <MenuItem className='flex justify-between items-center rounded-none hover:text-[#625afa] text-[#625afa] hover:bg-[#f7f7f7] py-[5px]'>
                                                <div className='flex gap-2 items-center font-medium'>
                                                    <LinkIcon className="fill-[#625afa] h-[16px] w-[16px]" /> Payment Link
                                                </div>
                                                <div className='flex gap-1 text-[12px] text-[#685387]'>
                                                    <div className='bg-[#f2f4f7] w-[16px] h-[16px] flex justify-center items-center rounded'>c</div>
                                                    <div className='bg-[#f2f4f7] w-[16px] h-[16px] flex justify-center items-center rounded'>l</div>
                                                </div>
                                            </MenuItem>
                                            <MenuItem className='flex justify-between items-center rounded-none hover:text-[#625afa] text-[#625afa] hover:bg-[#f7f7f7] py-[5px]'>
                                                <div className='flex gap-2 items-center font-medium'>
                                                    <PaymentIcon /> Payment
                                                </div>
                                                <div className='flex gap-1 text-[12px] text-[#685387]'>
                                                    <div className='bg-[#f2f4f7] w-[16px] h-[16px] flex justify-center items-center rounded'>c</div>
                                                    <div className='bg-[#f2f4f7] w-[16px] h-[16px] flex justify-center items-center rounded'>p</div>
                                                </div>
                                            </MenuItem>
                                        </MenuList>
                                    </Menu>
                                    <Menu placement='bottom-end'>
                                        <MenuHandler>
                                            <div className='flex items-center font-semibold text-[12px] gap-1 cursor-pointer'><InfoIcon />Help</div>
                                        </MenuHandler>
                                        <MenuList className='pb-2 text-[#687385] py-[8px] px-0 text-xs font-medium min-w-[168px]'>
                                            <MenuItem className='flex gap-2 items-center rounded-none text-[#625afa] hover:bg-[#f7f7f7] py-[5px] font-medium text-[14px] px-[12px] hover:text-[#625afa]'>Support articles <ShareIcon /></MenuItem>
                                            <MenuItem className='flex gap-2 items-center rounded-none text-[#625afa] hover:bg-[#f7f7f7] py-[5px] font-medium text-[14px] px-[12px] hover:text-[#625afa]'>Developer docs <ShareIcon /></MenuItem>
                                            <MenuItem className='flex gap-2 items-center rounded-none text-[#625afa] hover:bg-[#f7f7f7] py-[5px] font-medium text-[14px] px-[12px] hover:text-[#625afa]' onClick={() => setActive(true)}>Keyboard shortcuts</MenuItem>
                                        </MenuList>
                                    </Menu>
                                    <div className='flex items-center sm:gap-5 gap-2'>
                                        <Popover placement='bottom-end'>
                                            <PopoverHandler>
                                                <div className='cursor-pointer'><BellIcon /></div>
                                            </PopoverHandler>
                                            <PopoverContent className='max-w-[435px] w-full p-0 text-[#414552]'>
                                                <div className='font-semibold p-[16px_20px] border-b-[1px] border-[#ebeef1] text-base flex justify-between items-center'>
                                                    <span>Notifications</span>
                                                    <div className='text-[12px] text-[#b1b8c4]'>Mark all as read</div>
                                                </div>
                                                <div className='p-[16px_20px] flex flex-col items-center gap-0 border-b-[1px] border-[#ebeef1]'>
                                                    <span className='text-center'>No notifications yet</span>
                                                    <span className='text-center max-w-[255px] w-full'>Messages and alerts about your Stripe account will show up here.</span>
                                                </div>
                                                <div className='font-semibold p-[16px_20px] text-base gap-2'>
                                                    <button className='border-[2px] h-[30px] rounded-[6px] border-[#ebeef1] input_focus_shadow text-[14px] text-[#404452] focus:outline-none font-semibold p-[0_8px] w-full' onClick={() => setOpen(false)}>View preferences</button>
                                                </div>
                                            </PopoverContent>
                                        </Popover>
                                        <div className='cursor-pointer'><SettingIcon className="fill-gray-700 h-[16px] w-[16px]" /></div>
                                        <Popover placement='bottom-end' id="menu4Popover">
                                            <PopoverHandler>
                                                <button className='cursor-pointer' ><ProfileIcon /></button>
                                            </PopoverHandler>
                                            <PopoverContent className='max-w-[235px] relative z-20 top-[50px] w-full p-0 text-[#414552]'>
                                                <div className='font-semibold p-[12px] border-b-[1px] border-[#ebeef1] text-base'>
                                                    <span>{localStorage.getItem("email")}</span>
                                                    <div className='text-[12px] font-normal'>Administrator</div>
                                                </div>
                                                <div className='p-[8px_0]'>
                                                    <button onClick={() => navigate('/setting/user')} className='flex w-full gap-2 items-center rounded-none text-[#625afa] hover:bg-[#f7f7f7] py-[5px] font-medium text-[14px] px-[12px] hover:text-[#625afa]'>Profile</button>
                                                    <button onClick={() => { singOutUser(); setModal(true) }} className='flex w-full gap-2 items-center rounded-none text-[#625afa] hover:bg-[#f7f7f7] py-[5px] font-medium text-[14px] px-[12px] hover:text-[#625afa]'>Sign out</button>
                                                </div>
                                            </PopoverContent>
                                        </Popover>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='block md:hidden mt-3'>
                            <div className='relative mx-auto max-w-[500px] w-full group'>
                                <FiSearch className='absolute top-[6px] text-[14px] left-[10px] text-[#414552]' />
                                <input type="text" className='w-full focus:outline-none p-[4px_32px] text-[12px] h-[26px] text-[#6b7183] placeholder:text-[#6b7183] border-[1px] border-[#ebeef1] rounded-full bg-white placeholder:text-[12px] font-semibold' placeholder='Search...' />
                                <div className='h-[18px] text-[12px] w-[18px] group-hover:opacity-100 opacity-0 right-3 bg-[#f5f6f8] absolute flex items-center justify-center top-[4px] rounded'>/</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='bg-white border-b-[1px] border-[#ebeef1]'>
                    <div className="max-w-[1690px] mx-auto sm:px-[40px] px-[20px] py-[8px] w-full text-[#414552]">
                        <div className="flex justify-between">
                            <div className='flex gap-3 items-center'>
                                <div className='lg:flex hidden xl:gap-2 gap-1'>
                                    {menu.map((val, i) => {
                                        return (
                                            <Link to={val.route} key={i} className={`${(val.route === location.pathname || val.nav) ? "text-white bg-[#625afa]" : "text-[#1a1b25] bg-transparent hover:bg-[#ebeef1]"} focus:outline-none font-semibold capitalize p-[2px_10px] rounded-full text-[14px]`}>{val.name}</Link>
                                        )
                                    })}
                                </div>
                                <div className='lg:hidden block translate-y-[3px]'>
                                    <button onClick={() => setOpenMenu(true)} className='text-[#625afa]'><RiMenu2Line className='text-[18px]' /></button>
                                </div>
                                <button className='text-[#1a1b25] font-semibold capitalize p-[2px_10px] hover:bg-[#ebeef1] focus:outline-none rounded-full text-[14px] flex sm:gap-2 gap-1 items-center'>More <IoChevronDownSharp /></button>
                            </div>
                            <div className='flex sm:gap-3 gap-2 items-center'>
                                <button className='text-[#1a1b25] font-semibold capitalize sm:p-[2px_10px] hover:bg-[#ebeef1] focus:outline-none rounded-full sm:text-[14px] text-[12px]'>Developers</button>
                                <div className='flex sm:gap-3 gap-1 items-center'>
                                    <Popover open={openPopover} handler={setOpenPopover} placement='bottom-end'>
                                        <PopoverHandler {...triggers}>
                                            <button className='sm:text-[14px] text-[12px] text-[#a3acba] sm:font-semibold font-normal'>Test mode</button>
                                        </PopoverHandler>
                                        <PopoverContent {...triggers} className='w-[230px] p-[12px] mt-[10px]'>
                                            <span>Please <button onClick={() => navigate('/active-payment')} className='text-[#625afa] font-[500]'>activate your account</button> to access live data</span>
                                        </PopoverContent>
                                    </Popover>
                                    <div className="relative overflow-hidden">
                                        <div className="flex">
                                            <label className="inline-flex relative items-center sm:mr-5 gap-2 cursor-pointer">
                                                <input
                                                    type="checkbox"
                                                    className="sr-only peer"
                                                    checked={enabledCheck}
                                                    readOnly
                                                />
                                                <div
                                                    onClick={() => { setEnabledCheck(!enabledCheck) }}
                                                    className="w-[30px] h-[18px] bg-gray-200 rounded-full peer peer-focus:ring-[#f6b482] peer-checked:after:translate-x-[11px] peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-[14px] after:w-[14px] after:transition-all peer-checked:bg-[#f6b482]"
                                                ></div>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <AddAccountNameModal open={open} setOpen={setOpen} />
            <KeyShortcutSidebar active={active} setActive={setActive} />
            <Transition.Root show={modal} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={setModal}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-[#c1c9d2b3]" />
                    </Transition.Child>

                    <div className="fixed inset-0 z-10 overflow-y-auto">
                        <div className="flex min-h-full justify-center p-4 text-center items-center sm:p-0">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >
                                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-xs sm:p-6">
                                    <div className='py-[10px] flex flex-col gap-5 items-center'>
                                        <Spinner className='h-8 w-8' />
                                        <span className='font-semibold text-gray-600'>Signing out...</span>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
            <Transition.Root show={openMenu} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={setOpenMenu}>
                    <div className="fixed inset-0 bg-[#c1c9d2b3]" />

                    <div className="fixed inset-0 overflow-hidden">
                        <div className="absolute inset-0 overflow-hidden">
                            <div className="pointer-events-none fixed inset-y-0 left-0 flex max-w-full pr-10">
                                <Transition.Child
                                    as={Fragment}
                                    enter="transform transition ease-in-out duration-500 sm:duration-700"
                                    enterFrom="translate-x-[-100%]"
                                    enterTo="translate-x-0"
                                    leave="transform transition ease-in-out duration-500 sm:duration-700"
                                    leaveFrom="translate-x-0"
                                    leaveTo="translate-x-[-100%]"
                                >
                                    <Dialog.Panel className="pointer-events-auto w-screen max-w-sm">
                                        <div className="flex h-full flex-col overflow-y-scroll bg-white py-6 shadow-xl">
                                            <div className='px-[20px]'>
                                                <div className='flex justify-end'>
                                                    <button onClick={() => setOpenMenu(false)}><IoClose className='text-[25px] text-[#625afa]' /></button>
                                                </div>
                                                <div className='mt-10'>
                                                    <div className='flex flex-col gap-4'>
                                                        {menu.map((val, i) => {
                                                            return (
                                                                <Link to={val.route} key={i} className={`${(val.route === location.pathname || val.nav) ? "text-white bg-[#625afa]" : "text-[#1a1b25] bg-transparent hover:bg-[#ebeef1]"} focus:outline-none font-semibold w-max capitalize p-[2px_10px] rounded-full text-[16px]`}>{val.name}</Link>
                                                            )
                                                        })}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Dialog.Panel>
                                </Transition.Child>
                            </div>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
        </>
    )
}

export default DashboardHeader